import React, { useState } from 'react';
import Promotions from './Components/Promotions';
import PromotionDeta from './Components/PromotionDeta';
import './App.css';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [screenData, setScreenData] = useState(null);
  const [deviceInfo, setDeviceInfo] = useState({ deviceId: '', password: '' });

  // Handle successful login
  const handleLoginSuccess = (data, deviceId, password) => {
    setScreenData(data);
    setDeviceInfo({ deviceId, password });
    setIsLoggedIn(true);
  };

  // Handle logout/back to login
  const handleLogout = () => {
    setIsLoggedIn(false);
    setScreenData(null);
    setDeviceInfo({ deviceId: '', password: '' });
  };

  return (
    <div className="App">
      {!isLoggedIn ? (
        <Promotions onLoginSuccess={handleLoginSuccess} />
      ) : (
        <PromotionDeta 
          data={screenData} 
          deviceInfo={deviceInfo}
          onLogout={handleLogout}
        />
      )}
    </div>
  );
}

export default App;